<script setup>
import ReportPage from '../components/ReportPage.vue'
import { formatWon } from '../formatters.js'
</script>

<template>
  <ReportPage
    section="recommendations"
    eyebrow="07 · 함께 확인할 보장"
    title="건강 관리와 보장 준비, 따로 그러나 함께"
    lead="관리가 필요한 건강 영역과 연결된 보장 가운데 권장 금액에 못 미치는 항목을 앞에 두었습니다. 가입 권유가 아니라 확인 목록입니다."
    :customer-name="report.customer.name"
  >
    <table v-if="report.recommendations.length" class="plan">
      <thead><tr><th>보장항목</th><th class="r">보유</th><th class="r">권장</th><th class="r">부족</th></tr></thead>
      <tbody>
        <tr v-for="(item, index) in report.recommendations" :key="item.code">
          <td><span class="pk">{{ index + 1 }}</span>{{ item.name }}</td>
          <td class="r">{{ formatWon(item.currentWon) }}</td>
          <td class="r">{{ formatWon(item.targetWon) }}</td>
          <td class="r lack">{{ formatWon(item.gapWon) }}</td>
        </tr>
      </tbody>
    </table>
    <div v-else class="nocov">현재 연결 규칙에서 우선 보완 항목이 없습니다.</div>

    <div class="closing">
      <b>이 리포트를 보신 뒤</b>
<span>건강 소견은 검진기관과, 보장 내용은 가입한 상품의 약관과 지급조건을 함께 확인하세요.</span>
    </div>
  </ReportPage>
</template>

<script>
export default { props: { report: { type: Object, required: true } } }
</script>
